module.exports = __webpack_public_path__ + "static/media/min-Globe.bf26757d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/min-Globe.jpg
// module id = 1092
// module chunks = 0